import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Rodal from 'rodal';

import { STATE_TO_ABBREV } from '../../../constants';
import { fromQueryParams } from '../../../utils';

import './style.scss';

const NewRace = (props) => {
  const {
    createRace,
    elections,
    getAllElections,
    history,
    isLoggedIn,
    location: {
      search,
    },
    selectedElectionState,
    setSelectedElection,
  } = props;

  const { electionId } = fromQueryParams(search);

  if (!electionId) history.goBack();

  const [raceTitle, setRaceTitle] = useState('');
  const [racePositionDescription, setRacePositionDescription] = useState('');
  const [raceCounty, setRaceCounty] = useState('');

  const [errorText, setErrorText] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);

  useEffect(() => {
    if (elections.length === 0) {
      getAllElections();
    }
  }, [elections]);

  useEffect(() => {
    setSelectedElection(electionId);
  }, [elections, electionId]);

  useEffect(() => {
    if (!isLoggedIn) {
      setModalVisible(true);
    } else {
      setModalVisible(false);
    }
  }, [isLoggedIn]);


  const valueSetter = setter => (e) => {
    setter(e.target.value);
    setErrorText('');
  };

  const onSubmitPress = () => {
    const fields = {
      title: raceTitle,
      position_description: racePositionDescription,
      location: {
        state: STATE_TO_ABBREV[selectedElectionState],
        county: raceCounty,
        city: '',
        fips: '',
      },
      candidates: [],
    };

    if (!raceTitle) return setErrorText('Please provide a title for the race');
    if (!racePositionDescription) return setErrorText('Please provide a description of the position');

    return createRace(fields, electionId, () => {
      setSuccessModalVisible(true);
    }, (err) => {
      if (err.response.data === 'Unauthorized') {
        setErrorText('You must be signed in to report a new race');
      } else {
        setErrorText(JSON.stringify(err.response.data));
      }
    });
  };

  return (
    <div id="new-race-content">
      <h1>Report A New Race</h1>
      <div id="content-container">
        <table>
          <tr>
            <th>Title of Race</th>
            <th>
              <input className="val" value={raceTitle} onChange={valueSetter(setRaceTitle)} />
            </th>
          </tr>
          <tr>
            <th>Description of Position</th>
            <th>
              <input className="val" value={racePositionDescription} onChange={valueSetter(setRacePositionDescription)} />
            </th>
          </tr>
          <tr>
            <th>State</th>
            <th><p>{selectedElectionState}</p></th>
          </tr>
          <tr>
            <th>County (leave blank if state-wide race)</th>
            <th>
              <input className="val" value={raceCounty} onChange={valueSetter(setRaceCounty)} />
            </th>
          </tr>
        </table>
      </div>
      <div id="submit-container">
        {errorText && <p>{errorText}</p>}
        <button type="button" onClick={onSubmitPress}>
          Submit
        </button>
      </div>
      <Rodal visible={successModalVisible} onClose={() => setSuccessModalVisible(false)}>
        <div id="modal-success-content">
          <h2>Success!</h2>
          <p>We&apos;ve successfully added this race to our system.</p>
          <p>It will appear on the website once our moderators review it.</p>
          <button type="button" onClick={() => history.push(`/elections/${electionId}`)}>
            Back To Race
          </button>
        </div>
      </Rodal>
      <Rodal visible={modalVisible} onClose={() => setModalVisible(false)}>
        <div id="modal-no-auth-content">
          <h2>Uh oh!</h2>
          <p>Looks like you&apos;re not logged in.</p>
          <p>You must have an account to report races.</p>
          <h4 id="auth-prompt">Please <Link to="/sign-up">sign up</Link> or <Link to="/login">login</Link> to report a new race.</h4>
        </div>
      </Rodal>
    </div>
  );
};

export default NewRace;
